var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5502 26.5C3.5502 13.7509 13.8854 3.41574 26.6345 3.41574C39.3836 3.41574 49.7188 13.7509 49.7188 26.5C49.7188 39.2491 39.3836 49.5843 26.6345 49.5843C13.8854 49.5843 3.5502 39.2491 3.5502 26.5ZM26.6345 0.318665C12.1749 0.318665 0.453125 12.0405 0.453125 26.5C0.453125 40.9596 12.1749 52.6814 26.6345 52.6814C33.6738 52.6814 40.0643 49.9033 44.7693 45.3837C44.8284 45.4657 44.8965 45.543 44.9738 45.6142L63.9738 63.1142C64.5891 63.681 65.5474 63.6416 66.1142 63.0262C66.681 62.4109 66.6416 61.4526 66.0262 60.8858L47.0262 43.3858C46.9526 43.3181 46.8741 43.259 46.792 43.2085C50.5541 38.6749 52.8158 32.8516 52.8158 26.5C52.8158 12.0405 41.094 0.318665 26.6345 0.318665Z",
    fill: "#9EA9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.22665d4a.svg";
export { ForwardRef as ReactComponent };